import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@wit-support/ui';
export function HiddenWidget(props) {
    const { field } = props;
    return (_jsx(Input, { type: "hidden", name: field.name, value: String(field.value ?? ''), readOnly: true, className: "sr-only" }));
}
//# sourceMappingURL=hidden.js.map